import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ContentContainer from '../common/ContentContainer';
import { useTranslate } from '../../hooks/common';
import { TRANSLATIONS } from '../../constants';

const Home = () => {
    const dispatch = useDispatch();
    const translate = useTranslate();

    return (
        <ContentContainer>
            <h1>{translate(TRANSLATIONS.main.invalidProduct)}</h1>
        </ContentContainer>
    );
};

export default Home;
